window.onload = function(){ 
    
    $('#vid-wrap button.button.button--via-style').on("click", function() {
        $('.video-lm__video').html('<iframe loading="lazy" src="https://player.vimeo.com/video/321732977?autoplay=1&amp;loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media" allowfullscreen allowtransparency allow="autoplay"></iframe>'); 
        $('.video-lm__video').css("display", "contents");
        $('.video-lm__video').css("position", "relative");
        $('.plyr__video-embed iframe').css("z-index", "50001");
        $(this).toggle();
    });

};

/*

This is currently only set up for vimeo videos.  To change the video, change the video number
only. 
This is located in the code on line 3 above:
    $('.video-lm__video').html('<iframe loading="lazy" src="https://player.vimeo.com/video/321732977?autoplay=1&amp;loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media" allowfullscreen allowtransparency allow="autoplay"></iframe>'); 
    In this case the number is 321732977, change this number to the video number from the link to your video.
    Be careful not to remove the '/' before and the '?' after. 

If mistake is made editting remove lines 3-9 and paste in the code below


//--------------------------- This is for backup, in the case of a mistake when changing the video. ------------------------------------//

    $('#vid-wrap button.button.button--via-style').on("click", function() {
        $('.video-lm__video').html('<iframe loading="lazy" src="https://player.vimeo.com/video/321732977?autoplay=1&amp;loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media" allowfullscreen allowtransparency allow="autoplay"></iframe>'); 
        $('.video-lm__video').css("display", "contents");
        $('.video-lm__video').css("position", "relative");
        $('.plyr__video-embed iframe').css("z-index", "50001");
        $(this).toggle();
    });

*/